exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-63695202] {\n  font-size: 18px;\n}\n", ""]);

// exports
